import Backbone from 'backbone';
import $ from 'jquery';

import Auth from './model/auth';
import CheckLogin from './model/checklogin';
import Config from './config';
import Form from './view/form';
import UserRegister from './model/user.register';

import { ask, } from './utils/popups';
import { requestify, promisify } from './utils/promisify';

const fn = authCallback => Promise.resolve()
    .then( () => {
        // No token?  
        if (!Config.token())
            throw new Error();
    } )
    .then( () => {
        const cbUser = requestify( $.getJSON( Config.url( '/users/current') ) );
        const msUser = requestify( $.getJSON( `/users/current?token=${Config.token()}` ) );

        return Promise.all( [cbUser, msUser] )
            .then( ([cbResp, msResp]) => {
                // Token expired?
                if (+cbResp.res === 0)
                    throw new Error();
                if (!msResp.user)
                    throw new Error();

                return cbResp;
            } );
    } )
    // otherwise run authorization
    .catch( () => authCallback() )
    // remember auth data
    .then( subject => {
        const { id, token, fio, role_id, clusters, department_id, map_extent, organization_ids } = subject;
        const [cluster] = clusters;

        Config.token( token );
        Config.user( fio );
        Config.userId( id );
        Config.cluster( cluster ? cluster : null );
        Config.clusters( clusters );
        Config.role( role_id );
        Config.organization( department_id );
        Config.orgs( organization_ids.map( id => +id ) );
        Config.mapExtent( map_extent.map( number => +number ) );
        
        $( document.body ).on( 'click', '.logout-link', logout );

        delete subject.token;
        delete subject.res;
        delete subject.resText;

        return { subject, token: Config.token() };
    } );

export default fn( window.usePhoneAuthentication
        ? authByPhone
        : authByLogin );

function auth({ login, password }) {
    const cbAuth = requestify( new Auth( { login, password, } ).save() );
    const msAuth = requestify( $.ajax( {
        url: '/auth',
        data: { login, password },
        method: 'POST'
    } ) );

    return Promise.all( [cbAuth, msAuth] )
        .then( ([cbResp/*, msResp*/]) => cbResp )
        // cb or ms fail -> 
        //   cb ok -> look at ms
        //   cb fail -> fail, take cb message
        .catch( () => cbAuth.then( () => msAuth ) );
}

function authByLogin() {
    let form = new Form( {
        template: 'jst/auth.login.form'
    } );

    return ask( form.bind( new Auth() ),
        'auth::modal - title', 'actions::sign in', 'actions::cancel', 
        form => {
            form.enable( false );
            const { login, secretString } = form.model.toJSON();
            const process = auth( { login, password: secretString, } );
            process.then( () => form.enable(), () => form.enable() );
            return process;
        } );
}

function authByPhone() {
    firebase.initializeApp( {
        apiKey: "AIzaSyB9XK7kDbcn1YuUTgCg_2QXADDA9uXB4kE",
        authDomain: "fsminformkz.firebaseapp.com",
        databaseURL: "https://fsminformkz.firebaseio.com",
        projectId: "fsminformkz",
        storageBucket: "fsminformkz.appspot.com",
        messagingSenderId: "694779413752",
        appId: "1:694779413752:web:68f82a84bfd5db43ab270d"
    } );

    return ask( new Form( {
        template: 'jst/auth.phone.form'
    } ).bind( new Auth() ), 'auth::modal - title', 'Получить код', undefined, 
        form => new Promise( (resolve, reject) => {
            const btn = $( '#recaptcha' )[0];
            console.log( btn );
            const verifier = new firebase.auth.RecaptchaVerifier( btn, {
                size: 'invisible',
                callback: function(response) {
                    // todo captcha fail
                    console.log( 'got success recaptcha callback' );
                    firebase.auth().signInWithPhoneNumber( `+7${form.model.get( 'phone' )}`, verifier )
                        .then( resolve );
                }
            } ); 
            verifier.render().then( widgetId => {
                if (typeof grecaptcha !== 'undefined') {
                    grecaptcha.reset( widgetId );
                    grecaptcha.execute( widgetId );
                }
            } );
        } ) ).then( confirmationResult => ask( new Form( {
                template: 'jst/auth.code.form'
            } ).bind( new Auth() ), 'auth::modal - title', 'Подтвердить', undefined, form =>
                confirmationResult.confirm( form.model.get( 'code' ) )
                    .then( ({ user, ...attrs }) => { console.log( attrs, user ); return user; } )
                    .then( ({ phoneNumber, uid: password }) => ({ 
                        login: phoneNumber.replace( '+', '' ),
                        password,
                    }) )
                    .then( ({ login, password }) => promisify( new CheckLogin( { login } ).save() )
                        .then( response => { 
                            console.log( response );
                            if (response.check)
                                // todo organizationId
                                return promisify( new UserRegister( {
                                    login,
                                    paswd: password,
                                    fio: `User_${login}`,
                                    email: `User_${login}@t.t`,
                                    phone: `+${login}`,
                                    organization_id: 3,
                                    role_id: 6,
                                } ).save() ).then( () => ({
                                    login,
                                    password,
                                }) );

                            return { login, password, };
                         } ) )
                    .then( auth ) ) );
}

function logout() {
    Config.token( '' );
    Config.user( '' );
    Config.userId( '' );
    Config.role( '' );
    Config.organization( '' );
    
    // Logout from MapSurfer
    $.get( '/logout' ).always( () => location.assign( '/' ) );
}


// WEBPACK FOOTER //
// ./src/js/auth.js